<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar color="secondary" dark>
            <v-toolbar-title>
              <v-icon>mdi-clipboard-text</v-icon>Currencies
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
              <v-btn text @click="formOpen = true">
                <v-icon>mdi-plus</v-icon>Add Currency
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :option.sync="pagination"
            :server-items-length="totalCount"
          >
            <template #item.actions="{item}">
              <v-btn icon small @click="editItem(item)">
                <v-icon small class="mr-2">mdi-pencil</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
        <list-form
          :item="editedItem"
          :open="formOpen"
          v-on:add="addItem()"
          v-on:cancel="cancelItem()"
          v-on:update="updateItem()"
        ></list-form>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ListForm from "./_form";
import _ from "lodash";

export default {
  components: {
    ListForm
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "Name", value: "name"},
        { text: "Currency", value: "currency" },
        { text: "Tax Rate", value: "tva" },
        { text: "Actions", value:'actions' }
      ],
      pagination: { rowsPerPage: 20 },
      formOpen: false,
      editedItem: null
    };
  },
  watch: {
    pagination: {
      handler: _.debounce(function() {
        this.getLists();
      }, 100)
    },
    search: {
      handler: _.debounce(function() {
        this.getLists();
      }, 100)
    }
  },
  computed: {
    tableData: function() {
      return this.$store.getters["currencies/currencies"];
    },
    loading: function() {
      return this.$store.getters["currencies/loading"];
    },
    totalCount: function() {
      return this.$store.getters["currencies/totalCount"];
    }
  },
  mounted: function() {
    this.getLists();
  },
  methods: {
    getLists() {
      this.$store.dispatch("currencies/index", {
        pagination: this.pagination,
        search: this.search
      });
    },
    addItem() {
      this.formOpen = false;
      this.editedItem = null;
      this.getLists();
    },
    updateItem() {
      this.formOpen = false;
      this.editedItem = null;
      this.getLists();
    },
    cancelItem() {
      this.formOpen = false;
      this.editedItem = null;
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.formOpen = true;
    }
  }
};
</script>
